import { render, staticRenderFns } from "./orderConfirm.vue?vue&type=template&id=e57bbb94"
import script from "./orderConfirm.vue?vue&type=script&lang=js"
export * from "./orderConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports